import "./Pagination.css";
import arrowLeft from "../../../../assets/ion-arrow-left.png";
import arrowRight from "../../../../assets/ion-arrow-right.png";

const Pagination = () => {
 return (
  <>
   <div className="pagination-container">
    <div>Page 1 of 20</div>
    <div>
     <div>
      <img src={arrowLeft} alt="arrow left" />
     </div>
     <div>
      <img src={arrowRight} alt="arrow right" />
     </div>
    </div>
   </div>
  </>
 );
};

export default Pagination;
